import { useState, useContext, useCallback } from "react";
import { Tooltip, IconButton, Badge, Box } from "@mzc-pdc/ui";
import { IconNotice } from "@mzc-cloudplex/icons";
import { NotifyPopper } from "./notify-popper";
import theme from "@styles/theme";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { updateNewMessage } from "@modules/notify";
import { WebSocketContext } from "@routes/providers/webSocketProvider";
import i18n from "@lib/i18n";

export const NotifyButton = () => {
    const dispatch = useDispatch();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const notify = useSelector(({ notify }) => notify);
    const projects = useSelector(({ stage }) => stage.projects);

    const { sendMessage, isConnected } = useContext(WebSocketContext);

    const hasUnreadNotify = notify?.newMessage || false;

    const onHandleClickNotifyButton = useCallback(
        (event) => {
            setAnchorEl(event.currentTarget);
            dispatch(updateNewMessage(false));
        },
        [dispatch],
    );

    const onHandleClickClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    useEffect(() => {
        if (!isConnected || !sendMessage) return;

        sendMessage({
            action: "fetchMessages",
            data: { conditions: {} },
        });
    }, [isConnected, sendMessage]);

    return (
        <>
            <Badge
                color="error"
                variant="dot"
                invisible={!hasUnreadNotify}
                sx={{
                    "& .MuiBadge-badge": {
                        right: theme.spacing(1.25),
                        top: theme.spacing(1.25),
                    },
                }}
            >
                <Box
                    sx={{
                        ...(hasUnreadNotify && {
                            "&::before": {
                                content: '""',
                                position: "absolute",
                                top: theme.spacing(0.75),
                                right: theme.spacing(0.75),
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                                border: `2px solid ${theme.palette.error.main}`,
                                animation: "pulse 1.5s ease-out infinite",
                                zIndex: 1,
                            },
                        }),
                        "@keyframes pulse": {
                            "0%": {
                                transform: "scale(0)",
                                opacity: 0,
                            },
                            "50%": {
                                opacity: 0.5,
                            },
                            "100%": {
                                transform: "scale(2.5)",
                                opacity: 0,
                            },
                        },
                    }}
                >
                    <Tooltip title={i18n.t(`common::label::Notifications`, `Notifications`)}>
                        <IconButton circled size="large" onClick={onHandleClickNotifyButton}>
                            <IconNotice size={20} htmlColor={theme.palette.greySecondary.main} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Badge>

            <NotifyPopper open={open} anchorEl={anchorEl} onClickClose={onHandleClickClose} projects={projects} />
        </>
    );
};
